/* eslint-disable no-undef */

function redirect(path) {
  window.location.href = path;
};

function logOutParent(){
  console.log('log out parent now');
  let win = window.parent;
  win.postMessage("logout", "*");
}

const helpers = {
  redirect,
  logOutParent
};

export default helpers;



// WEBPACK FOOTER //
// ./src/helpers/helpers.js